module.exports = __webpack_public_path__ + "static/media/guide-line-03.343dbdd4.svg";